module.exports = __webpack_public_path__ + "img/esports_demo-1-600x450.ae1ee72f.jpg";